export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Videoanleitungen und Hilfe",
    guidesTip: "Anleitungen und Hilfe",
    availabilityPricesTitle: "Verfügbarkeit & Preise",
    hotelCalendarSubtitle: "Verfügbarkeit und Buchungen pro Zimmer",
    availabilityPricesSubtitle: "Preise, Verfügbarkeit und Mindestaufenthalt",
  },
  maquetaNav: {
    guidesAria: "Videoanleitungen und Hilfe",
    guidesTip: "Anleitungen und Hilfe",
    novedadesAria: "Systemneuheiten",
    novedadesTip: "Neuigkeiten",
    tourTip: "Neuigkeiten: geführte Tour",
    tourAria: "Tour mit den Neuigkeiten öffnen",
    backToPanel: "Zurück zum Panel",
    accountTitle: "Kontoeinstellungen",
    agentIaTitle: "KI-Agent",
    directBookingsTitle: "Direktbuchungen",
    listingsTitle: "Inserat-Einstellungen",
  },
  navMovil: {
    menuTitle: "Menü",
    home: "Start",
    calendar: "Kalender",
    reservations: "Buchungen",
    checkins: "Check-ins",
    housekeeping: "Reinigung",
    channels: "Buchungskanäle",
    settings: "Einstellungen",
    settingsDesktopOnly: "Nur in der Desktop-Version verfügbar",
    experiences: "Erlebnisse",
  },
  register: {
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutz",
    loginError: "Fehler beim Anmelden.",
  },
  buttonSave: {
    savingRoom: "Zimmer wird gespeichert...",
  },
  firstForm: {
    name: "Vorname",
    phone: "Telefon",
  },
  final: {
    guestsRegistered: "Registrierte Gäste",
    registrationsCompleted: "Abgeschlossene Registrierungen",
    registrationTime: "Registrierungszeit: ",
    shareRegistrationLink: "Registrierungslink teilen",
  },
  scannerPdf417: {
    captureCode: "Code erfassen",
    focusInstruction: "Fokussieren und erfassen Sie den Barcode auf Ihrem Ausweis",
  },
  configNotifications: {
    title: "Benachrichtigungen",
    propertyLabel: "Unterkunft",
    phoneInstruction: "Geben Sie die Telefonnummer an, über die Sie per WhatsApp Benachrichtigungen zu Serviceanfragen oder Check-ins Ihrer Gäste erhalten möchten",
    saveWhatsapp: "WhatsApp speichern",
    editWhatsapp: "WhatsApp bearbeiten",
    configTitle: "Einstellungen",
    serviceNotifications: "Service-Benachrichtigungen",
    checkinNotifications: "Check-in-Benachrichtigungen",
    active: "An",
    inactive: "Aus",
    whatsappRequired: "Sie müssen die WhatsApp-Nummer eingeben",
    swalTitle: "WhatsApp für die Benachrichtigungen Ihrer Unterkunft",
    swalText: "Sie erhalten alle Benachrichtigungen zu angefragten Services und Check-ins der Gäste ",
    cancel: "Abbrechen",
    whatsappAdded: "WhatsApp erfolgreich hinzugefügt",
  },
  modalPoliceData: {
    headerSub: "Geben Sie Ihre Zugangsdaten für das System ein",
    closeAria: "Schließen",
    entityName: "Name der Behörde",
    usernamePlaceholder: "Benutzernamen eingeben",
    passwordPlaceholder: "Passwort eingeben",
    hide: "Ausblenden",
    show: "Anzeigen",
    lessorExample: "z. B. 12345",
    establishmentExample: "z. B. 67890",
    saving: "Wird gespeichert…",
    listingNotFound: "Das zugehörige Inserat wurde nicht gefunden.",
    saveFailed: "SES Hospedajes konnte nicht gespeichert werden.",
  },
  notificaciones: {
    title: "Benachrichtigungen",
    propertyLabel: "Unterkunft",
    phoneInstruction: "Geben Sie die Telefonnummer an, über die Sie per WhatsApp Benachrichtigungen zu Serviceanfragen oder Check-ins Ihrer Gäste erhalten möchten",
    saveWhatsapp: "WhatsApp speichern",
    editWhatsapp: "WhatsApp bearbeiten",
    configTitle: "Einstellungen",
    serviceNotifications: "Service-Benachrichtigungen",
    checkinNotifications: "Check-in-Benachrichtigungen",
    active: "An",
    inactive: "Aus",
    whatsappRequired: "Sie müssen die WhatsApp-Nummer eingeben",
    swalTitle: "WhatsApp für die Benachrichtigungen Ihrer Unterkunft",
    swalText: "Sie erhalten alle Benachrichtigungen zu angefragten Services und Check-ins der Gäste ",
    cancel: "Abbrechen",
    whatsappAdded: "WhatsApp erfolgreich hinzugefügt",
  },
  admins: {
    listTitle: "Liste der Verwalter",
    newManager: "Neuer Verwalter",
    today: "Heute",
    thName: "Name",
    thEmail: "E-Mail",
    thRegistered: "Registriert",
    edit: "Bearbeiten",
    delete: "Löschen",
    userLabel: "Benutzername",
    emailLabel: "E-Mail",
    passwordLabel: "Passwort",
    cancel: "Abbrechen",
    save: "Speichern",
    createdOk: "Erfolgreich erstellt",
    requestError: "Fehler bei der Anfrage",
    updatedOk: "Erfolgreich aktualisiert",
    deletedOk: "Erfolgreich gelöscht",
  },
};
